export default __webpack_public_path__ + "static/media/psych.674516bb.svg";